export default function () {
  this.getTowers()
}



// WEBPACK FOOTER //
// ./src/app/dweller/unit/form/resources/mounted.js